import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { getRouteParams, getThemeLargeLogo } from '../../services/angular-bridge';
import { notifySuccess, notifyError } from '../../services/notify';
import { navigateToAngular } from '../../services/navigate';
import { SubmitButton } from '../../components/SubmitButton';

export function ResetPasswordPage() {
  const isVerify = window.location.hash.includes('/verify/');
  const { email, accountId, passwordResetToken } = getRouteParams();

  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [dirty, setDirty] = useState({ password: false, password2: false });

  useEffect(() => {
    if (isVerify) {
      notifySuccess({
        title: 'Email address verified!',
        description: 'Now just enter your password and log in',
        timeout: 5000,
      });
    }
  }, []);

  const passwordsMatch = password === password2;
  const isValid = password.length > 0 && password2.length > 0 && passwordsMatch;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isValid || submitting) return;
    setSubmitting(true);
    try {
      await api.post('/account/reset', { password, email, accountId, token: passwordResetToken });
      notifySuccess({
        title: 'Password Reset',
        description: 'Please log in with your new password',
        timeout: 5000,
      });
      navigateToAngular('/');
    } catch {
      // Generic message by design — do not surface the server response here.
      notifyError({ title: 'Password reset failed', description: 'Please try again.', timeout: 5000 });
      setSubmitting(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-8">
        <img src={getThemeLargeLogo()} className="login" alt="Folio" />

        <div className="page-header">
          <h1>{isVerify ? 'Choose password' : 'Password reset'}</h1>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className={`form-group${dirty.password && !password ? ' has-error' : ''}${dirty.password2 && dirty.password && !passwordsMatch ? ' has-error' : ''}`}>
            {dirty.password && !password && (
              <span className="help-block">Password is required</span>
            )}
            {dirty.password && dirty.password2 && !passwordsMatch && (
              <span className="help-block">Passwords must match</span>
            )}
            <input
              type="password"
              placeholder="Password"
              className="form-control"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onBlur={() => setDirty(d => ({ ...d, password: true }))}
              disabled={submitting}
              required
            />
          </div>

          <div className={`form-group${dirty.password2 && (!password2 || !passwordsMatch) ? ' has-error' : ''}`}>
            {dirty.password2 && !password2 && (
              <span className="help-block">Password Again is required</span>
            )}
            <input
              type="password"
              placeholder="Password Again"
              className="form-control"
              value={password2}
              onChange={e => setPassword2(e.target.value)}
              onBlur={() => setDirty(d => ({ ...d, password2: true }))}
              disabled={submitting}
              required
            />
          </div>

          <div className="form-group">
            <SubmitButton pending={submitting} pendingLabel="Submitting..." disabled={!isValid}>Save</SubmitButton>
          </div>
        </form>
      </div>
    </div>
  );
}
